import { createReducer } from '@reduxjs/toolkit';
import type { SavedSearch, SearchParameters } from 'lib-shared-types-api';
import type { MarkRequired } from 'ts-essentials';

import { filtersInitialState } from './components/filters/utils/definitions';
import { searchActions } from './search.actions';

type SearchState = {
  params: MarkRequired<SearchParameters, 'filters'>;
  savedSearch?: SavedSearch;
};

export const initialState: SearchState = {
  params: {
    scope: 'conversations',
    query: '',
    filters: filtersInitialState,
    sort: undefined,
    strict: false,
    page: 1,
  },
};

export const searchReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(searchActions.params.update, (state, action) => {
      Object.assign(state.params, {
        ...action.payload,
        filters: Object.assign(state.params.filters, action.payload.filters),
        page: action.payload.page ?? 1,
      });
    })

    .addCase(searchActions.savedSearch.apply, (state, action) => {
      state.savedSearch = action.payload;

      Object.assign(state.params, {
        ...action.payload.params,
        page: 1,
      });
    })
    .addCase(searchActions.savedSearch.close, (state) => {
      state.params = {
        ...initialState.params,
        scope: state.params.scope,
      };
      delete state.savedSearch;
    }),
);
